export function pluralization(n: number, titles: string[]) {
  return titles[
    n % 10 === 1 && n % 100 !== 11
      ? 0
      : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)
        ? 1
        : 2
  ]
}

export function formatIntlPhoneString(phone: string) {
  if (phone.startsWith('8')) {
    phone = '7' + phone.slice(1)
  }

  if (phone.startsWith('+')) {
    phone = phone.slice(1)
  }

  return `+${phone.slice(0, 1)} (${phone.slice(1, 4)}) ${phone.slice(
    4,
    7
  )} ${phone.slice(7, 9)}-${phone.slice(9, 11)}`
}

export const getRemainingWord = (num: number): string => {
  return num % 10 === 1 && num % 100 !== 11 ? 'Остался' : 'Осталось'
}

export const DAY_WORDS = ['день', 'дня', 'дней']
export const HOUR_WORDS = ['час', 'часа', 'часов']
export const MINUTE_WORDS = ['минута', 'минуты', 'минут']

export const getDaysPluralization = (daysCount: number) => {
  return pluralization(daysCount + 1, DAY_WORDS)
}

export const getHoursPluralization = (hoursCount: number) => {
  return pluralization(hoursCount, HOUR_WORDS)
}

export const getMinutesPluralization = (minutesCount: number) => {
  return pluralization(minutesCount, MINUTE_WORDS)
}

export const isProjectIdValid = (projectId?: string | null): boolean => {
  if (projectId) {
    return /^[\da-f]{8}-[\da-f]{4}-[0-5][\da-f]{3}-[089ab][\da-f]{3}-[\da-f]{12}$/.test(
      projectId
    )
  }

  return false
}

const cleanAllSigns = (value: string) => {
  return value.replaceAll(/\D/g, '')
}

export const formatNumber = (value: string) => {
  if (value === null || value === undefined || value === '') {
    return undefined
  }

  if (typeof value === 'number') {
    return value
  }

  const locale = window.navigator.language || 'ru'
  const numberWithDecimal = 12_345.6

  const parts = Intl.NumberFormat(locale).formatToParts(numberWithDecimal)
  const decimal = parts.find(part => part.type === 'decimal')?.value

  const decimalIndex = value.indexOf(decimal ?? '.')

  if (decimalIndex === -1) {
    return cleanAllSigns(value)
  }

  const integerPart = value.slice(0, decimalIndex)
  const fractionalPart = value.slice(decimalIndex + 1)

  const cleanedIntegerPart = cleanAllSigns(integerPart)

  return cleanedIntegerPart + '.' + fractionalPart
}
